import React from 'react'
import withIcon from '@/components/withIcon'

const IconTreatmentServices = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3647_98606)">
        <path
          d="M17.625 16.125H19.368C19.9853 16.125 20.593 16.2774 21.1373 16.5686C21.6816 16.8598 22.1455 17.2809 22.488 17.7945L22.875 18.375L11.499 22.8C10.8402 23.0566 10.1301 23.1543 9.4265 23.0852C8.72285 23.0162 8.04538 22.7823 7.449 22.4025L1.125 18.375V11.625H2.625C4.59825 11.625 6.8535 12.3503 7.875 13.875H11.625C12.6196 13.875 13.5734 14.2701 14.2767 14.9733C14.9799 15.6766 15.375 16.6304 15.375 17.625H7.125"
          stroke="#162941"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M19.0351 2.7424C18.7807 2.476 18.4764 2.26234 18.1394 2.11363C17.8024 1.96492 17.4394 1.88408 17.0711 1.87572C16.7029 1.86736 16.3366 1.93165 15.9932 2.06492C15.6498 2.19819 15.3361 2.39782 15.0699 2.6524C14.8989 2.81517 14.7494 2.99917 14.6251 3.1999C14.3993 2.83635 14.0932 2.5293 13.7304 2.30227C13.3675 2.07524 12.9576 1.93425 12.5319 1.89009C12.1062 1.84594 11.676 1.89978 11.2743 2.04751C10.8726 2.19525 10.51 2.43294 10.2144 2.7424C9.6756 3.30688 9.375 4.0572 9.375 4.83752C9.375 5.61784 9.6756 6.36817 10.2144 6.93265L14.6251 11.4979L19.0359 6.93265C19.5747 6.36816 19.8753 5.61775 19.8751 4.83737C19.875 4.057 19.5741 3.30669 19.0351 2.7424Z"
          stroke="#162941"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_3647_98606">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default withIcon(IconTreatmentServices)
